import api from './api';

export const getShiftClosures = async (pointOfSaleId, params = {}) => {
  const response = await api.get('/ventas/shift-closures', {
    params: { point_of_sale_id: pointOfSaleId, ...params },
  });
  return response.data;
};

export const closeShift = async (payload) => {
  const response = await api.post('/ventas/shift-closures', payload);
  return response.data;
};

export const reopenShift = async ({ point_of_sale_id, shift_date }) => {
  const response = await api.post('/ventas/shift-closures/reopen', {
    point_of_sale_id,
    shift_date,
  });
  return response.data;
};
